module.exports = __webpack_public_path__ + "img/1_m.d0c4d040.jpg";